import React from 'react';
import BrandingVariables from 'app/components/layouts/BrandingVariables';
import LegacyLibraryBranding from 'app/components/layouts/LegacyLibraryBranding';

import 'app/deprecated/assets/stylesheets/app.scss';

export default function DeprecatedStyles(props) {
  return (
    <>
      <BrandingVariables />
      <LegacyLibraryBranding fileName="library_branding.css" />
      <div {...props} />
    </>
  );
}
